export default __webpack_public_path__ + "assets/images/6ad6bcaee733c7260ae5fc96895c5794.png";